module.exports = __webpack_public_path__ + "img/img122.086b4fe2.png";